import { useState } from 'react';
import { ArrowRight, Check, Loader2 } from 'lucide-react';
import { subscribeNewsletter } from '@/lib/api';
import { toast } from 'sonner';

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    try {
      await subscribeNewsletter(email);
      setIsSuccess(true);
      setEmail('');
      toast.success('Successfully subscribed!');
      setTimeout(() => setIsSuccess(false), 3000);
    } catch (error) {
      toast.error('Subscription failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="relative" data-testid="newsletter-form">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email"
        className="input-underline pr-12 text-sm"
        data-testid="newsletter-email-input"
        required
      />
      <button
        type="submit"
        disabled={isLoading || isSuccess}
        className="absolute right-0 bottom-2 p-2 text-white/50 hover:text-gold transition-colors disabled:opacity-50"
        data-testid="newsletter-submit-btn"
        aria-label="Subscribe"
      >
        {isLoading ? (
          <Loader2 size={18} className="animate-spin" />
        ) : isSuccess ? (
          <Check size={18} className="text-green-500" />
        ) : (
          <ArrowRight size={18} />
        )}
      </button>
    </form>
  );
};

export default NewsletterForm;
